const init_header = require('./parts/_header');
const init_anchor = require('./parts/_anchor');
const init_scroll_to_top = require('./parts/_scroll-to-top');
const init_cta_subject = require('./parts/_cta-subject');
const init_publications = require('./parts/_publications');

function initialize_all() {
  init_header();
  init_anchor();
  init_scroll_to_top();
  init_cta_subject();
  init_publications();
}

if (document.readyState !== 'loading') {
  initialize_all();
} else {
  document.addEventListener('DOMContentLoaded', initialize_all);
}


